import { render, staticRenderFns } from "./VehiclePreviousOwnerships.vue?vue&type=template&id=13688287&scoped=true&"
import script from "./VehiclePreviousOwnerships.vue?vue&type=script&lang=js&"
export * from "./VehiclePreviousOwnerships.vue?vue&type=script&lang=js&"
import style0 from "./VehiclePreviousOwnerships.vue?vue&type=style&index=0&id=13688287&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13688287",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13688287')) {
      api.createRecord('13688287', component.options)
    } else {
      api.reload('13688287', component.options)
    }
    module.hot.accept("./VehiclePreviousOwnerships.vue?vue&type=template&id=13688287&scoped=true&", function () {
      api.rerender('13688287', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VehiclePreviousOwnerships.vue"
export default component.exports